<template>
  <div class="login">
    <form @submit.prevent="handleSubmit">
      <div>
        <label>
          Email Address<br />
          <input :disabled="isLoading" type="email" v-model="email" />
        </label>
      </div>
      <div>
        <label>
          Password<br />
          <input
            :disabled="isLoading"
            type="password"
            v-model="password"
            required
          />
        </label>
      </div>
      <div>
        <button :disabled="!email || !password || isLoading" type="submit">
          Login
        </button>
        <span v-if="isLoading">LOADING</span>
      </div>
      <p v-if="loginFailed">
        The email and password you entered did not match our records. Please try
        again.
      </p>
    </form>
  </div>
</template>

<script>
import { ref } from "vue";
import store from "@/store";
import { startCase } from "lodash";

export default {
  name: "Login",
  methods: {
    handleSubmit() {
      this.isLoading = true;
      this.loginFailed = false;

      store
        .dispatch("user/loginUser", {
          email: this.email,
          password: this.password
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            this.loginFailed = true;
            this.isLoading = false;
            return;
          }

          if (error.response && error.response.status === 403) {
            store.dispatch(
              "app/flashError",
              startCase(error.response.data.message)
            );
            this.isLoading = false;
            return;
          }

          this.isLoading = false;
          store.dispatch("app/flashError");
        });
    }
  },
  setup() {
    const email = ref(null);
    const password = ref(null);
    const loginFailed = ref(false);
    const isLoading = ref(false);

    return {
      email,
      password,
      loginFailed,
      isLoading
    };
  }
};
</script>

<style lang="scss" scoped>
.login {
  padding: 100px;
}
</style>
